'use client';

const getRestProps = ({
  label: _label,
  a11yLabel: _a11yLabel,
  caption: _caption,
  dataQa: _dataQa,
  active: _active,
  variant: _variant,
  status: _status,
  disabled: _disabled,
  role: _role,
  leadSymbol: _leadSymbol,
  endSymbol: _endSymbol,
  ...rest
}) => rest;
export {
  getRestProps
};
